module.exports = __webpack_public_path__ + "assets/07b2dedb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nature-yellow.png
// module id = 98
// module chunks = 0